import BaseCost from '@/model/BaseCost.js'

export class ScheduledRateChangeCreateRequest {
  constructor (contractId, effectiveDate, deletedActivityIds, updatedActivities, newActivities, note = null) {
    this.contractId = contractId
    this.effectiveDate = effectiveDate
    this.deletedActivityIds = deletedActivityIds
    this.updatedActivities = updatedActivities
    this.newActivities = newActivities
    this.note = note?.trim() || null
  }
}

export class ScheduledActivityUpdateRequest {
  constructor (
    effectiveDate,
    contractId,
    templateId,
    contractorId,
    runtimeCounterparty,
    recoveryMode,
    advanceId,
    newPayBy,
    newPayOn,
    newRate,
    newRateSheet,
    newDetailRates,
    activityId,
    deductFromActivityIdentifier,
    deductFromActivityId
  ) {
    this.effectiveDate = effectiveDate
    this.contractId = contractId
    this.templateId = templateId
    this.contractorId = contractorId
    this.runtimeCounterparty = runtimeCounterparty
    this.recoveryMode = recoveryMode
    this.advanceId = advanceId
    this.baseCost = new BaseCost({
      rate: newRate,
      payBy: newPayBy,
      payOn: newPayOn,
      rateSheet: newRateSheet
    })
    this.activityDetails = newDetailRates
    this.activityId = activityId
    this.deductFromActivityIdentifier = deductFromActivityIdentifier
    this.deductFromActivityId = deductFromActivityId
  }
}

export class ScheduledActivityCreateRequest {
  constructor (
    effectiveDate,
    contractId,
    templateId,
    contractorId,
    runtimeCounterparty,
    recoveryMode,
    advanceId,
    newPayBy,
    newPayOn,
    newRate,
    newRateSheet,
    newDetailRates,
    deductFromActivityIdentifier,
    deductFromActivityId,
    namedRateId
  ) {
    this.effectiveDate = effectiveDate
    this.contractId = contractId
    this.templateId = templateId
    this.contractorId = contractorId
    this.runtimeCounterparty = runtimeCounterparty
    this.recoveryMode = recoveryMode
    this.advanceId = advanceId
    this.baseCost = new BaseCost({
      rate: newRate,
      payBy: newPayBy,
      payOn: newPayOn,
      rateSheet: newRateSheet
    })
    this.activityDetails = newDetailRates
    this.deductFromActivityIdentifier = deductFromActivityIdentifier
    this.deductFromActivityId = deductFromActivityId
    this.namedRateId = namedRateId
  }
}

export class ScheduledDetailRateChangeRequest {
  constructor (productId, newRate) {
    this.productId = productId
    this.rate = newRate
  }
}
